import { AsyncPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';
import { WishlistCmsComponents } from '@core/const';
import { SdvorTabBarItemComponent } from '@sdvor/shared/ui';
import { CmsConfig, ConfigModule, UrlModule } from '@spartacus/core';
import { WishlistButtonComponent } from './wishlist-button.component';

@NgModule({
  imports: [
    AsyncPipe,
    RouterLink,
    UrlModule,
    SdvorTabBarItemComponent,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [WishlistCmsComponents.RosaCMSWishlistButtonComponent]: {
          component: WishlistButtonComponent,
        },
      },
    }),
  ],
  declarations: [WishlistButtonComponent],
  exports: [WishlistButtonComponent],
})
export class WishlistButtonModule {}
